module.exports = __webpack_public_path__ + "img/1920-ai-bg.aca6c82b.jpg";